import {useEffect, useState} from "react";
import useMyCase from "./useMyCase";
import DobDisambiguationModal from "./DobDisambiguationModal";
import {DOB_RESOLVED_EVENT, readStoredDob} from "./dobSession";

// Mount once after login so Home / My Case / orientation never render for the
// wrong household member when a shared phone/email needs DOB disambiguation.
//
// onParticipantName: after a DOB-scoped success, push CRM first/last so the
// header can show the matched person (DynamoDB still has one shared name).
// Single-participant logins never store a DOB — those keep the DDB name.
const MyCaseDobGate = ({loggedInUser, onParticipantName}) => {
  const {status, caseData, submitDob, dobError, dobSubmitting} =
    useMyCase(loggedInUser);
  const customerId = loggedInUser?.customer_id;
  // submitDob applies success then storeDob; re-run the name push when DOB
  // lands so we don't miss the callback (readStoredDob was still empty on
  // the success-only render).
  const [dobEpoch, setDobEpoch] = useState(0);

  useEffect(() => {
    if (!customerId) return undefined;
    const onResolved = (e) => {
      if (e?.detail?.customerId && e.detail.customerId !== customerId) return;
      setDobEpoch((n) => n + 1);
    };
    window.addEventListener(DOB_RESOLVED_EVENT, onResolved);
    return () => window.removeEventListener(DOB_RESOLVED_EVENT, onResolved);
  }, [customerId]);

  useEffect(() => {
    if (status !== "success" || !customerId || !onParticipantName) return;
    // Only override the header when this session used DOB disambiguation.
    if (!readStoredDob(customerId)) return;
    // Always notify — even with blank CRM names — so App keeps a non-null
    // participantName and never falls back to the household DynamoDB name.
    onParticipantName({
      firstname: caseData?.firstName || "",
      lastname: caseData?.lastName || "",
    });
  }, [status, caseData, customerId, onParticipantName, dobEpoch]);

  return (
    <DobDisambiguationModal
      open={status === "needs_dob"}
      onSubmit={submitDob}
      dobError={dobError}
      submitting={dobSubmitting}
    />
  );
};

export default MyCaseDobGate;
